import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUsersOrganizationMaterialSet } from './getLoggedInUsersOrganizationMaterialSetSelector';

export const getHangerListsRecord = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  (materialSet) => materialSet?.hangerLists,
);

export const getHangerLists = createSelector(getHangerListsRecord, (hangerLists) => Object.values(hangerLists ?? {}));
